import { render, staticRenderFns } from "./TablePassengers.vue?vue&type=template&id=6acd4151&"
import script from "./TablePassengers.vue?vue&type=script&lang=js&"
export * from "./TablePassengers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6acd4151')) {
      api.createRecord('6acd4151', component.options)
    } else {
      api.reload('6acd4151', component.options)
    }
    module.hot.accept("./TablePassengers.vue?vue&type=template&id=6acd4151&", function () {
      api.rerender('6acd4151', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/72235100-2/components/TablePassengers.vue"
export default component.exports